import { render, staticRenderFns } from "./paymentClientTable.vue?vue&type=template&id=216598d4&"
import script from "./paymentClientTable.vue?vue&type=script&lang=js&"
export * from "./paymentClientTable.vue?vue&type=script&lang=js&"
import style0 from "./paymentClientTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports